<template>
  <div id="menubar" :class="{hide: !show}">
    <MenubarLogo
      src="./assets/images/menubar-logo.png"
      :alt="`F8th ${lang.logo}`"
      :show="show"
    />
    <div class="sub-menubar top">
      <LanguageBar />
      <span class="split">|</span>
      <span>1-833-388-4678</span>
    </div>
    <div class="sub-menubar">
      <MenubarTab
        v-for="tab in tabs"
        :key="tab.id"
        :to="tab.to"
        :scroll-to="tab.scrollTo"
        :label="lang[tab.id]"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tabs from "@/data/tabs"
import { scrollY } from "@/assets/js/utils"
import MenubarLogo from "./MenubarLogo";
import MenubarTab from "./MenubarTab";
import LanguageBar from "@/components/shared/LanguageBar";

export default {
  name: "Menubar",
  components: { MenubarLogo, MenubarTab, LanguageBar },
  data: function() {
    return {
      scrollY: 0,
      show: true,
      tabs: tabs
    };
  },
  methods: {
    setShow() {
      let scrollPosition = scrollY()
      if (this.scrollY > scrollPosition) this.show = true;
      else if (this.scrollY < scrollPosition && this.scrollY) this.show = false;
      this.scrollY = scrollPosition;
    }
  },
  created: function() {
    window.addEventListener("scroll", this.setShow);
    this.setShow();
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.setShow);
  },
  computed: {
    ...mapGetters("languages", ["lang"])
  }
};
</script>

<style lang="scss" scoped>
#menubar {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: $menubar-height;
  top: 0;
  margin-top: 0;
  color: $menubar-color;
  background-color: $menubar-background-color;
  overflow: hidden;
  transition-property: margin-top;
  transition-duration: $menubar-transition-duration;
  transition-timing-function: $menubar-transition-timing-function;
  &.hide {
    margin-top: $menubar-height/-2;
  }
  .sub-menubar {
    width: 100%;
    height: $menubar-height/2;
    line-height: $menubar-height/2;
    text-align: right;
    &.top {
      @extend #{$menubar-top-font-size};
      padding-right: $menubar-top-padding-right;
    }
  }
  .split {
    display: inline-block;
    margin: 0 1vw;
  }
}
</style>
